/**
 * kult-b2b-links.js — hält Besucher im Firmenkunden-Bereich (Entscheidung Philip 06.10.2026: keine Privatkunden-Seite
 * verlinken, kein Kult-Club). Läuft nur, wenn der Header data-kult-mode="b2b" trägt (lädt ihn dort). Schreibt interne Links
 * im Seiteninhalt um, dieselben Regeln wie snippets/kult-b2b-url.liquid (Header und Footer werden serverseitig umgeschrieben):
 *   ueber-uns → /pages/firmenkunden#roesterei, kaffeeseminare → /pages/team-events, contact → /pages/firmenkunden#kontakt,
 *   versand-zahlung → /pages/firmenkunden-versand, faq → /pages/firmenkunden-faq, kaffeewissen/kaffeezubereitung/kaffeefinder →
 *   /pages/buerokaffee, geschenke und geschenke-* → /pages/firmenpraesente, unsere-kaffees → /collections/kaffee?view=b2b,
 *   kult-club/mein-kult-club → /pages/firmenkunden (Links mit „Club“/„Status“/„Abo“ im Text werden ausgeblendet),
 *   kuendigen/widerruf unverändert (§ 312k, § 356a BGB), Rechtsseiten aus data-kult-b2b-views ({"handle":"recht-b2b"}) → ?view=recht-b2b, Firmenkunden-Seiten
 *   (data-kult-b2b-pages oder Handle beginnt mit „firmen“) unverändert, alle übrigen /pages/… und /blogs/… sowie „/“ →
 *   /pages/firmenkunden, /collections/…, /products/…, /cart → ?view=b2b (wenn kein view gesetzt).
 *   /account (Konto-Link in Header, Footer-Menü) → /pages/firmenkonto (Mein Firmenkonto, 12.10.2026).
 *   Unverändert: „/“ mit [data-kult-b2c-switch] (Für Privatkunden), /account/…, externe Adressen, reine Anker, data-kult-keep.
 *   Anker bleiben erhalten, außer das Ziel hat einen eigenen.
 * Läuft beim Laden und erneut nach Warenkorb-Updates (Ereignis kult:cart:updated) für nachgeladene Inhalte.
 */
(function () {
  'use strict';
  if (window.__kultB2bLinks) return;
  window.__kultB2bLinks = true;

  var MAP = {
    'ueber-uns': '/pages/firmenkunden#roesterei',
    'kaffeeseminare': '/pages/team-events',
    'contact': '/pages/firmenkunden#kontakt',
    'versand-zahlung': '/pages/firmenkunden-versand',
    'faq': '/pages/firmenkunden-faq',
    'kaffeewissen': '/pages/buerokaffee',
    'kaffeezubereitung': '/pages/buerokaffee',
    'kaffeefinder': '/pages/buerokaffee',
    'geschenke': '/pages/firmenpraesente',
    'unsere-kaffees': '/collections/kaffee?view=b2b'
  };
  // Kündigen (§ 312k BGB) und Widerrufen (§ 356a BGB) bleiben erreichbar (Rechtsprüfung 06.10.2026)
  var KEEP = { 'kuendigen': true, 'widerruf': true };
  var CLUB = { 'kult-club': true, 'mein-kult-club': true };

  // hidden allein reicht nicht, wenn die Section-CSS display setzt (z. B. .kult-kw-cta__links { display: flex })
  function hide(el) { el.hidden = true; el.style.setProperty('display', 'none', 'important'); }

  // Kult-Club gilt nicht für Firmen: Links mit Club-, Status- oder Abo-Beschriftung ausblenden; mitten im Satz als Text stehen lassen
  function dropClubLink(a) {
    var wrap = a.parentElement;
    var rest = '';
    if (wrap) { var probe = wrap.cloneNode(true); Array.prototype.forEach.call(probe.querySelectorAll('a'), function (x) { x.remove(); }); rest = (probe.textContent || '').trim(); }
    if (wrap && wrap !== document.body && wrap.children.length === 1 && !rest) { hide(wrap); return; }
    var after = '';
    for (var n = a.nextSibling; n; n = n.nextSibling) after += n.textContent || '';
    var inline = wrap && /^(P|LI|DD|TD|SPAN|EM|STRONG)$/.test(wrap.tagName) && /\w/.test(after);
    if (!inline) { hide(a); return; }
    var span = document.createElement('span');
    span.textContent = a.textContent;
    a.replaceWith(span);
  }

  function withParam(path, param) { return path + (path.indexOf('?') > -1 ? '&' : '?') + param; }

  function run() {
    var header = document.querySelector('[data-kult-mode="b2b"]');
    if (!header) return;
    var views = {};
    try { views = JSON.parse(header.getAttribute('data-kult-b2b-views') || '{}') || {}; } catch (e) { views = {}; }
    var b2bPages = {};
    (header.getAttribute('data-kult-b2b-pages') || '').split(',').forEach(function (h) { h = h.trim(); if (h) b2bPages[h] = true; });
    var links = document.querySelectorAll('a[href^="/"]:not([data-kult-keep]):not([data-kult-b2c-switch])');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('[data-kult-b2c-switch]')) return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('//') === 0) return;
      var hashIdx = href.indexOf('#');
      var hash = hashIdx > -1 ? href.slice(hashIdx) : '';
      var path = hashIdx > -1 ? href.slice(0, hashIdx) : href;
      // Konto-Link im Firmenkunden-Bereich (12.10.2026): „Mein Konto“ führt auf das Firmenkonto, übrige /account/… unverändert
      if (path === '/account' || path === '/account/') { a.setAttribute('href', '/pages/firmenkonto' + hash); return; }
      if (!path || path.indexOf('/account') === 0) return;
      var next = path;
      if (path === '/' || path.indexOf('/blogs/') === 0) {
        next = '/pages/firmenkunden';
      } else if (path.indexOf('/pages/') === 0) {
        var handle = path.slice(7).split('?')[0];
        if (CLUB[handle]) {
          if (/club|status|abo\b/i.test(a.textContent || '')) { dropClubLink(a); return; }
          next = '/pages/firmenkunden';
        } else if (MAP[handle]) next = MAP[handle];
        else if (handle.indexOf('geschenke-') === 0) next = '/pages/firmenpraesente';
        else if (KEEP[handle] || path.indexOf('view=') > -1 || b2bPages[handle] || handle.indexOf('firmen') === 0) next = path;
        else if (views[handle]) next = withParam(path, 'view=' + views[handle]);
        else next = '/pages/firmenkunden';
      } else if (path.indexOf('view=') === -1 && (path.indexOf('/collections/') === 0 || path.indexOf('/products/') === 0 || path === '/cart' || path.indexOf('/cart?') === 0)) {
        next = withParam(path, 'view=b2b');
      }
      if (next !== path) a.setAttribute('href', next.indexOf('#') > -1 ? next : next + hash);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('kult:cart:updated', function () { window.setTimeout(run, 50); });
})();
